import styles from './WarningLabel.css'

const WarningLabel = ({content}) => {
  return <div className={styles['wrapper']}>
    <i className={`fa fa-exclamation-circle ${styles.circle}`} />
    <label className={`${styles.content}`}>{content}</label>
  </div>
}

export default WarningLabel



// WEBPACK FOOTER //
// ./app/pages/Reports/Sales/GrossProfit/WarningLabel/WarningLabel.js